// File: cgp-alert-dialog.service.ts
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: CGP Alert Dialog to use instead of js alert.
// Other Contributors:

import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

import { CgpAlertDialogComponent } from './cgp-alert-dialog.component';

const defaults = {
    title: '',
    message: '',
    alert: '',
    height: '',
    width: '',
    closeLabel: 'Close',
    onClosed: null
};

@Injectable()
export class CgpAlertDialogService {
    constructor(private readonly dialog: MatDialog) { }
    private isDialogOpen = false;

    showAlertDialog(opts) {
        this.isDialogOpen = true;
        const options = {
            ...defaults,
            ...opts
        };

        let dialogRef: MatDialogRef<CgpAlertDialogComponent>;

        dialogRef = this.dialog.open(CgpAlertDialogComponent, options);
        dialogRef.componentInstance.title = options.title;
        dialogRef.componentInstance.message = options.message;
        dialogRef.componentInstance.alert = options.alert;
        dialogRef.componentInstance.closeLabel = options.closeLabel;

        dialogRef.afterClosed().subscribe(result => {
            if (options.onClosed) {
                options.onClosed();
            }
            this.isDialogOpen = false;
        });

        return dialogRef;
    }

    isOpen() {
        return this.isDialogOpen;
    }
}
